import state from "./state.js"
import mutations from "./mutations/index.js"
import actions from "./actions/index.js"
import getters from "./getters/index.js"

export default {
	state,
	mutations,
	actions,
	getters
}
